import React from 'react';

const FAQ = () => {
  const faqs = [
    {
      question: 'How long does rust removal and protection treatment take?',
      answer: 'Treatment time varies by project size and complexity. Small automotive jobs typically take 1-2 days, while large industrial projects may require 1-2 weeks. We provide detailed timelines during our free assessment.',
    },
    {
      question: 'Do you offer free rust assessments?',
      answer: 'Yes! We provide comprehensive free assessments for all potential projects. Our certified technicians will evaluate the extent of corrosion and recommend the best protection strategy.',
    },
    {
      question: 'How long do your protective coatings last?',
      answer: 'Our premium coating systems are designed to last 10-15 years under normal conditions. We offer extended warranties and maintenance plans to ensure long-term protection.',
    },
    {
      question: 'Can you work on-site or do I need to bring equipment to you?',
      answer: 'We offer both mobile on-site services and facility-based treatments. For large equipment or multiple assets, our mobile units can come directly to your location.',
    },
    {
      question: 'What types of equipment do you service?',
      answer: 'We service all types of metal equipment including automotive, marine vessels, heavy machinery, industrial equipment, structural steel, and more. If it\'s metal and prone to rust, we can protect it.',
    },
    {
      question: 'Is your rust protection environmentally safe?',
      answer: 'Yes, we use environmentally responsible products and methods. Our coatings are non-toxic once cured and we follow all environmental guidelines for disposal and application.',
    },
    {
      question: 'Do you provide emergency rust response?',
      answer: 'We offer 24/7 emergency response for critical equipment failure prevention. Our rapid response team can address urgent rust damage to minimize downtime.',
    },
    {
      question: 'What is included in your preventative maintenance plans?',
      answer: 'Our maintenance plans include regular inspections, touch-up treatments, cleaning, and reapplication of protective coatings as needed. Plans are customized based on your equipment and environment.',
    },
  ];

  return (
    <div>
      {/* Hero Section */}
      <section className="relative min-h-[60vh] flex items-center w-full bg-gray-900 dark:bg-black">
        
        <div className="relative z-10 px-6 lg:px-8 py-20 text-center text-white w-full max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">
            Frequently Asked <span className="text-orange-400">Questions</span>
          </h1>
          <p className="text-xl md:text-2xl mb-8 opacity-90">
            Find answers to common questions about our rust protection services
          </p>
        </div>
      </section>

      {/* FAQ Content */}
      <section className="py-20 px-6 bg-white dark:bg-gray-900">
        <div className="max-w-4xl mx-auto">
          <div className="space-y-8">
            {/* FAQ Item 1 */}
            <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-6">
              <h3 className="text-xl font-semibold mb-3 text-gray-900 dark:text-white">
                What areas do you service?
              </h3>
              <p className="text-gray-600 dark:text-gray-300">
                We provide rust protection services throughout the greater metropolitan area. Our mobile service can reach most locations within a 50-mile radius of our main office.
              </p>
            </div>

            {/* FAQ Item 2 */}
            <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-6">
              <h3 className="text-xl font-semibold mb-3 text-gray-900 dark:text-white">
                How long does rust protection treatment last?
              </h3>
              <p className="text-gray-600 dark:text-gray-300">
                Our rust protection treatments typically last between 2-5 years, depending on environmental conditions and maintenance. We recommend annual inspections to ensure optimal protection.
              </p>
            </div>

            {/* FAQ Item 3 */}
            <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-6">
              <h3 className="text-xl font-semibold mb-3 text-gray-900 dark:text-white">
                Do you offer emergency services?
              </h3>
              <p className="text-gray-600 dark:text-gray-300">
                Yes, we provide 24/7 emergency rust protection services for critical situations. Our rapid response team can be on-site within hours to address urgent rust issues.
              </p>
            </div>

            {/* FAQ Item 4 */}
            <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-6">
              <h3 className="text-xl font-semibold mb-3 text-gray-900 dark:text-white">
                What types of equipment do you protect?
              </h3>
              <p className="text-gray-600 dark:text-gray-300">
                We protect a wide range of equipment including industrial machinery, vehicles, marine equipment, agricultural tools, and structural components. Our solutions are customised for each specific application.
              </p>
            </div>

            {/* FAQ Item 5 */}
            <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-6">
              <h3 className="text-xl font-semibold mb-3 text-gray-900 dark:text-white">
                How much does rust protection cost?
              </h3>
              <p className="text-gray-600 dark:text-gray-300">
                Costs vary based on the size of the project, type of equipment, and specific protection needs. We offer free assessments and detailed quotes with no obligation. Contact us for a personalised estimate.
              </p>
            </div>

            {/* FAQ Item 6 */}
            <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-6">
              <h3 className="text-xl font-semibold mb-3 text-gray-900 dark:text-white">
                Do you provide maintenance plans?
              </h3>
              <p className="text-gray-600 dark:text-gray-300">
                Yes, we offer comprehensive maintenance plans that include regular inspections, touch-up treatments, and priority service. These plans help ensure long-term protection and can be customised to your needs.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQ;
